import { render, staticRenderFns } from "./Databank.vue?vue&type=template&id=3ffc967f&scoped=true"
import script from "./Databank.vue?vue&type=script&lang=js"
export * from "./Databank.vue?vue&type=script&lang=js"
import style0 from "./Databank.vue?vue&type=style&index=0&id=3ffc967f&prod&scoped=true&lang=css"
import style1 from "./Databank.vue?vue&type=style&index=1&id=3ffc967f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffc967f",
  null
  
)

export default component.exports